import React from 'react'
import tooltipIcon from "../../components/targetmarketanalysis/assets/tooltip.svg"
import { Tooltip } from 'antd'
import "./tooltipCustomStyle.css"

const ToolTip = ({ tooltip, icon=tooltipIcon, placement }) => <Tooltip placement={placement} title={tooltip}><img src={icon} alt="" /></Tooltip>

export default ToolTip